// Import JS Modules
import fetchImage from '../../_utils/fetch-image';

// -----------------------------------------------------------
// RawImageCache
// -----------------------------------------------------------
const RawImageCache = (function () {
  let list = [];
  let generation = 0;

  return {
    cache(url) {
      if (!url) return;

      let item = find(url);
      if (!item) {
        item = {
          url,
          image: fetch(url),
        };
        list.push(item);
      }
      item.generation = generation;
      return item;
    },
    get(url, callback) {
      if (!url) return;

      const { image } = this.cache(url);
      if (image.complete && typeof image.naturalWidth !== 'undefined' && image.naturalWidth != 0) {
        // image is loaded
        callback(image);
        return;
      }

      // image isn't loaded - yet
      image.onload = function () {
        callback(this);
      };
    },
    newGen() {
      generation++;
    },
    gc() {
      const newList = [];
      for (let i = 0; i < list.length; i++) {
        if (list[i].generation == generation) {
          newList.push(list[i]);
        }
      }
      list = newList;
    },
  };

  function find(url) {
    for (let i = 0; i < list.length; i++) {
      if (list[i].url === url) return list[i];
    }
  }

  function fetch(url) {
    return fetchImage(url.replace(/^https?:/, ''), '');
  }
})();

export default RawImageCache;
